var _style, _text, _text2, _text3, _text4, _text5, _text6, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _polyline, _polyline2, _text7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneTimeCourseInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4D4D4D;}\n\t.st1{font-family:'Arial-BoldMT';}\n\t.st2{font-size:23.9562px;}\n\t.st3{font-size:15.4384px;}\n\t.st4{letter-spacing:-1;}\n\t.st5{fill:none;stroke:#4D4D4D;stroke-width:3;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#4D4D4D;stroke-width:2;stroke-miterlimit:10;}\n\t.st7{fill:none;stroke:#4D4D4D;stroke-width:1.65;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#4D4D4D;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:6;}\n\t.st9{fill:none;stroke:#4D4D4D;stroke-width:1.65;stroke-miterlimit:10;stroke-dasharray:6;}\n\t.st10{fill:none;stroke:#4D4D4D;stroke-width:5;stroke-miterlimit:10;}\n\t.st11{fill:none;stroke:#4D4D4D;stroke-width:5;stroke-miterlimit:10;stroke-dasharray:6;}\n\t.st12{font-family:'Helvetica-Bold';}\n")), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(6.123234e-17 -1 1 6.123234e-17 19.8604 350.8516)",
    className: "st0 st1 st2"
  }, "L")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(6.123234e-17 -1 1 6.123234e-17 19.8604 338.9902)",
    className: "st0 st1 st2"
  }, "og")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(6.123234e-17 -1 1 6.123234e-17 28.7241 312.9492)",
    className: "st0 st1 st3"
  }, "2")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(6.123234e-17 -1 1 6.123234e-17 19.8604 298.8867)",
    className: "st0 st1 st2 st4"
  }, "F")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(6.123234e-17 -1 1 6.123234e-17 19.8604 287.0508)",
    className: "st0 st1 st2"
  }, "old Change")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 17.562 399.875)",
    className: "st0 st1 st2"
  }, "0")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 63.2,
    y1: 145.5,
    x2: 64.6,
    y2: 423.7
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 46.8,
    y1: 390,
    x2: 511.3,
    y2: 389.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 109.4,
    y1: 284.8,
    x2: 109.4,
    y2: 260.9
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 109.4,
    y1: 284.4,
    x2: 109.4,
    y2: 308.4
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 326.8,
    y1: 330.1,
    x2: 326.8,
    y2: 282.1
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 326.8,
    y1: 329.7,
    x2: 326.8,
    y2: 398.2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 317,
    y1: 211.2,
    x2: 317,
    y2: 187.3
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 317,
    y1: 210.8,
    x2: 317,
    y2: 234.8
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 109.4,
    y1: 387.8,
    x2: 109.4,
    y2: 363.8
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 109.4,
    y1: 387.4,
    x2: 109.4,
    y2: 411.3
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 402.2,
    y1: 204.9,
    x2: 402.2,
    y2: 193.3
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 402.2,
    y1: 204.7,
    x2: 402.2,
    y2: 216.3
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 491.8,
    y1: 376.1,
    x2: 491.8,
    y2: 364.5
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 491.8,
    y1: 375.9,
    x2: 491.8,
    y2: 387.6
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "401.7,204.6 317.4,212.5 228.7,252.5 108,284.4 63.7,390 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st11",
    points: "494,377.6 329,365.1 63.7,390 "
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 196.1367 101.2568)",
    className: "st0 st12 st2"
  }, "Tissue")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneTimeCourseInactive);
export default __webpack_public_path__ + "static/media/GeneTimeCourse_inactive.792c451487678895a007038ec7a44dad.svg";
export { ForwardRef as ReactComponent };